import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Equipment, getEquipments, createEquipment, updateEquipment, deleteEquipment } from '../../services/equipmentService';

interface EquipmentState {
  items: Equipment[];
  total: number;
  currentPage: number;
  totalPages: number;
  loading: boolean;
  error: string | null;
}

const initialState: EquipmentState = {
  items: [],
  total: 0,
  currentPage: 1,
  totalPages: 1,
  loading: false,
  error: null,
};

export const fetchEquipments = createAsyncThunk(
  'equipment/fetchEquipments',
  async ({ page, limit }: { page: number; limit: number }) => {
    const response = await getEquipments(page, limit);
    return response;
  }
);

export const fetchAllEquipments = createAsyncThunk(
  'equipment/fetchAllEquipments',
  async () => {
    const response = await getEquipments();
    return response;
  }
);

export const createEquipmentAsync = createAsyncThunk(
  'equipment/createEquipment',
  async (data: Partial<Equipment>) => {
    const response = await createEquipment(data);
    return response;
  }
);

export const updateEquipmentAsync = createAsyncThunk(
  'equipment/updateEquipment',
  async ({ id, data }: { id: number; data: Partial<Equipment> }) => {
    const response = await updateEquipment(id, data);
    return response;
  }
);

export const deleteEquipmentAsync = createAsyncThunk(
  'equipment/deleteEquipment',
  async (id: number) => {
    await deleteEquipment(id);
    return id;
  }
);

const equipmentSlice = createSlice({
  name: 'equipment',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEquipments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEquipments.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
        state.total = action.payload.total;
        state.currentPage = action.payload.page;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchEquipments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch equipment';
      })
      .addCase(deleteEquipmentAsync.fulfilled, (state, action) => {
        state.items = state.items.filter(item => item.id !== action.payload);
      });
  },
});

export default equipmentSlice.reducer; 